export const MIN_SUPPORTED_WIDTH = 1040;
export const XL_BREAKPOINT_WIDTH = 1440;

export const breakpoints = {
  ['3xl']: 'screen and (min-width: 2000px)',
  xxl: 'screen and (min-width: 1920px)',
  xl: 'screen and (min-width: 1440px)',
  xlg: 'screen and (min-width: 1280px)',
  lg: 'screen and (min-width: 1040px)',
  sm: 'screen and (min-width: 880px)',
  xs: 'screen and (min-width: 600px)',
  xxs: 'screen and (min-width: 400px)',
  ['max-xl']: 'screen and (max-width: 1919px)',
  ['max-xlg']: 'screen and (max-width: 1439px)',
  ['max-lg']: 'screen and (max-width: 1279px)',
  ['max-sm']: 'screen and (max-width: 1039px)',
  ['mobile']: 'screen and (max-width: 599px)',
  ['max-xxs']: 'screen and (max-width: 399px)',
};
